import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'contact-rating',
  imports: [FontAwesomeModule],
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: RatingComponent, multi: true }]
})
export class RatingComponent implements ControlValueAccessor {
  protected emptyStar = faStar;
  protected filledStar = solidStar;
  protected starValues = [1, 2, 3, 4, 5];
  protected value: number | null = null;

  private touched = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange = (rating: number): any => {};
  private onTouched = (): any => {};

  public writeValue(rating: number): void {
    this.value = rating;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public onRatingSelect(rating: number): void {
    this.markAsTouched();
    this.value = rating;
    this.onChange(this.value);
  }

  private markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
